import * as React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

import {ShowingsType} from 'features/search/enums';
import {ResidenceCardData} from "features/search/types";
import {Showing as ShowingType} from "features/search/types";
import {useAuth} from "features/authentication/hooks/useAuth";
import {StageStatus} from "features/search/filters/enums";
import {getCardUrl, isNotChildSite} from 'features/services/utils/url-helper';
import {getShowingCardDate, getVIPShowingEnd, getVIPShowingStart} from 'features/services/utils/date-helpers';
import {getFirstValidShowing, hasShowing, showingIsFuture, showingIsVisible} from 'features/services/utils/showing-helpers';

import './style.scss';

import {A} from 'components/atoms/LinksAndButtons/A';
import {Icon} from 'components/atoms/Media/Icon';
import { getFormattedMessage } from 'features/services/utils/language-helper';
import { LinkStyle } from 'features/ui/enums';

interface Props {
    residence: ResidenceCardData;
    offsetPosition?: boolean;
}

export const ShowingTag: React.FunctionComponent<Props> = ({residence, offsetPosition}) => {
    const {user} = useAuth();
    const userIsVip = user ? user.isVip : false;
    const dummyText = residence.hasExtraShowingsInfo ? 'yes' : '';
    const url = getCardUrl(residence);
    const childSite = isNotChildSite(residence.siteId);

    let filteredShowings: ShowingType[] = [];

    if (residence.showings) {
        filteredShowings = residence.showings.filter(x => showingIsFuture(x));
    }

    const showing = filteredShowings.length > 0 ? getFirstValidShowing(filteredShowings, residence.vipStart) : null;
    const isShowingVisible = showing !== null ? showingIsVisible(showing, userIsVip) : false;

    const classNames = classnames('showing-tag__showing', {
        'showing-tag__top': !offsetPosition,
        'showing-tag__offset': offsetPosition,
    });

    if(!hasShowing(filteredShowings, residence.stageStatus, dummyText)) return null;
    if(residence.stageStatus === StageStatus.PLANNED && showing === null) return null;
    //if(residence.stageStatus === StageStatus.PLANNED && residence.residenceType !== ResidenceType.APARTMENT) return null;
    if(showing === null && !residence.hasExtraShowingsInfo) return null;

    return (
        <A 
            className={classNames} 
            href={url + '#showings'}
            target={childSite ? '' : '_blank'}
            variant={LinkStyle.DARK_BG}
            title={showing && isShowingVisible
                ? showing.type === ShowingsType.VIP
                    ? getVIPShowingStart(showing.startDate) + ' - ' + getVIPShowingEnd(showing.endDate)
                    : getShowingCardDate(showing.startDate)
                : getFormattedMessage('jm.components.Showings.privateInfo')} 
        >
            <Icon 
                name="showing" 
                //size={12} 
                className="showing-tag__icon" 
            />
            {showing && isShowingVisible 
                ? showing.type === ShowingsType.VIP
                    ? <>{getVIPShowingStart(showing.startDate)} - {getVIPShowingEnd(showing.endDate)}</>
                    : getShowingCardDate(showing.startDate)
                : <FormattedMessage id="jm.components.Showings.privateInfo" />
            }
        </A>
    );
};